<script lang="ts" setup>
import { useBrand } from '~/composables/useBrand';
import { useSchemaOrg, defineWebPage } from '@unhead/schema-org/vue';

const route = useRoute();
const localePath = useLocalePath();

const { data: brand , fetchBrand } = useBrand();
const { data: searchData } = useSearch();

await fetchBrand();

useSeoMeta({
    title: brand.value?.meta_title,
    description: brand.value?.meta_description,
    ogTitle: brand.value?.meta_title,
    ogDescription: brand.value?.meta_description,
});

useSchemaOrg([
    defineWebPage({
        title: brand.value?.meta_title,
        description: brand.value?.meta_description,
    }),
]);

const paginationLinks = computed(() => {
  const links = [];
  const currentPage = searchData.value?.pagination?.current_page || 1;
  const totalPages = searchData.value?.pagination?.pages_count || 1;
  const baseUrl = route.path;

  if (currentPage > 1) {
    const prevPage = currentPage - 1;
    const prevUrl = prevPage === 1 ? baseUrl : `${baseUrl}?page=${prevPage}`;
    links.push({
      rel: 'prev',
      href: prevUrl,
    });
  }

  if (currentPage < totalPages) {
    const nextPage = currentPage + 1;
    links.push({
      rel: 'next',
      href: `${baseUrl}?page=${nextPage}`,
    });
  }

  return links;
});

useHead(() => ({
  link: paginationLinks.value,
}));
</script>

<template>
  <VContainer class="relative">
    <Breadcrumbs
      class="mt-4"
      :breadcrumbs="[
        { title: 'Home', url: localePath('/') },
        { title: 'Brands', url: localePath('/brands') },
        { title: brand?.name ?? '', url: localePath(route.fullPath) }
      ]"
    />

    <VProductListing 
      :brandId="brand?.link_rewrite"
      :title="brand?.name"
      :short_description="brand?.short_description"
      :description="brand?.description"
      :cover_image="brand?.cover_image"
    />
  </VContainer>
</template>
